/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Week_SundayInputs */



/**
* | output |
* | --- |
* | "Sunday" |
*
* @param {Settings_Week_SundayInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_week_sunday = /** @type {((inputs?: Settings_Week_SundayInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Week_SundayInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zondag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dimanche")
	return /** @type {LocalizedString} */ ("Sunday")
});